import { css } from '@emotion/react';

export const socialMedias = css`
  display: flex;
  & svg {
    height: 32px;
    width: 32px;
  }
  gap: 26px;
`;
